var _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIncreaseLifeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54.341px",
    height: "49.875px",
    viewBox: "0 0 54.341 49.875",
    enableBackground: "new 0 0 54.341 49.875",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.747,24.938 28.511,29.702 40.496,17.717 40.496,29.106 43.474,29.106 43.474,12.655 27.022,12.655  27.022,15.632 38.411,15.632 28.511,25.459 23.747,20.695 9.454,34.987 11.613,37.146 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.977,2.978h48.387v43.919H2.977V2.978z M0,49.875h54.341V0.001H0V49.875z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncreaseLifeline);
export default __webpack_public_path__ + "static/media/icon-increase-lifeline.6c3a4b5c55a8374c70a39d9a77ac2180.svg";
export { ForwardRef as ReactComponent };